// extracted by mini-css-extract-plugin
export default {"container":"Search_container__Lrasb","search":"Search_search__heyB5"};